import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import './AppointmentConfirmation.css';
import { GET_APPOINTMENTDETAILS, UPDATE_APPOINTMENT_STATUS } from '../../../GraphQLQueries/appointment';
import useApi from '../../../../../../hooks/useQuery';
import { AppointmentDetail } from '../types/appointmentDetailsType';
import useMutationApi from '../../../../../../hooks/useMutation';



interface AppointmentConfirmationModalProps {
  show: boolean;
  onClose: () => void;
  onConfirm?: () => void;
  appointmentId: string,
  statusTag: string
}

const AppointmentConfirmationModal: React.FC<AppointmentConfirmationModalProps> = ({ show, onClose, onConfirm, appointmentId, statusTag }) => {

  const exampleAppointment: AppointmentDetail = {
    id: "",
    patientName: "",
    patientMobileNumber: "",
    doctorName: null,
    receiptUrl: null,
    appointmentStartTime: "",
    appointmentEndTime: "",
    latestStatus: "",
    outstandingAmount: 0,
    createdDate: "",
    netAmount: 0,
    receiptNo: "",
    labRoomName: "",
    labRoomId: "",
    gender: "",
    scanTestDetails: [
      {
        testGroupName: "",
        testDetails: [
          {
            testName: "",
            testNameId: "",
            testGroupId: "",
            price: 0,
            maleLowerRange: "",
            maleUpperRange: "",
            femaleLowerRange: "",
            femaleUpperRange: "",
            unit: "",
          },
        ],
      },
    ],
    paymentDetails: [
      {
        paymentStatus: "",
        paymentMode: "",
        cashIn: 0,
        cashOut: 0,
        totalAmount: 0,
        transactionAmount: 0,
        outstandingBalance: 0,
        transactionDate: "",
      },
    ],
  };

  const [apptDetails,
    setApptDetails
  ] = useState<AppointmentDetail>(exampleAppointment)

  const {
    loading,
    error,
    data,
  } = useApi("", GET_APPOINTMENTDETAILS, {
    id: appointmentId
  })

  const {
    createData,
    loading: updateApptLoading,
    error: updateApptError,
    data: dataUpdateAppt
  } = useMutationApi(UPDATE_APPOINTMENT_STATUS)







  const handleConfirm = async () => {
    console.log("Confirming appointment with ID:", appointmentId, "and status:", "Waiting For Results");
    await createData({
      id: appointmentId,
      appointmentStatus: 'Waiting For Results'
    })

    if (onConfirm) onConfirm();
    onClose();
  };

  useEffect(() => {
    const assignData = async () => {
      if (data) {
        await setApptDetails(data.getDiagnosisAppointmentDetailById)
      }
    }
    assignData()
  }, [data])


  return (
    <Modal
      show={show}
      dialogClassName='ePulse-modal ePulse-modal-50w'
      onHide={onClose}
      backdrop='static'
    >
      <Modal.Header className='border-0' closeButton>
        <span className='fs-3 fw-bold'>Appointment Details</span>
      </Modal.Header>
      <Modal.Body className="p-4">
        {/* Header */}
        <h6 className="mb-3">Appointment No. : <span className="fw-bold">{apptDetails.receiptNo}</span></h6>
        <div className="d-flex align-items-center mb-4">
          <i className="bi bi-person-fill fs-4 me-2 text-secondary"></i>
          <span className="me-4">{apptDetails.patientName}</span>
          <i className="bi bi-telephone-fill fs-4 me-2 text-secondary"></i>
          <span>{apptDetails.patientMobileNumber}</span>
        </div>

        {/* Services */}
        {/* {services.map((svc, i) => (
          <div key={i} className="card mb-2 shadow-sm">
            <div className="card-body py-3">
              <span className="fw-medium">{i + 1}. {svc}</span>
            </div>
          </div>
        ))} */}

        {/* Appointment Date & Time */}
        <div className="d-flex align-items-center mt-4 mb-1">
          <i className="bi bi-calendar-event fs-4 me-2 text-secondary"></i>
          <h6 className="mb-0">Appointment Date &amp; Time</h6>
        </div>
        <p className="ms-4 mb-4">{new Date(apptDetails.appointmentStartTime).toLocaleString()}</p>
        {/* Payment */}
        <div className="d-flex align-items-center mb-1">
          <i className="bi bi-currency-rupee fs-4 me-2 text-secondary"></i>
          <h6 className="mb-0">Payment 1 : ₹ {apptDetails.paymentDetails[0].cashIn}</h6>
          <span className={`badge ms-auto ${apptDetails.paymentDetails[0].paymentStatus === "Paid" ? "bg-success" : "bg-secondary"
            }`}>{apptDetails.paymentDetails[0].paymentStatus}</span>
        </div>
        <p className="ms-4 mb-4">{new Date(apptDetails.paymentDetails[0].transactionDate).toLocaleString()}</p>
        <hr />

        {/* Total & Confirm */}
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h5 className="mb-0">Total Order Amount : ₹ {apptDetails.netAmount}</h5>
        </div>
        <button
          type="button"
          className="ePulse-btn-primary"
          onClick={handleConfirm}
        >
          CONFIRM
        </button>
      </Modal.Body>
    </Modal>
  );
};

export default AppointmentConfirmationModal;

function useStata<T>(arg0: null): [any, any] {
  throw new Error('Function not implemented.');
}
